module.exports = __webpack_public_path__ + "img/plant.f79e531c.svg";